import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import Swal from "sweetalert2";
import Menu from "../menu";
import { Button, Icon, Input, Modal, Pagination, Select, Table } from "../../components";
import { axios, Colors, Globals } from "../../utils";

const STATUS = {
  PENDING: 0,
  IN_PROGRESS: 1,
  FINISHED: 2,
};

const INITIAL_FORM = {
  search: "",
  status: "",
  zone_id: "",
}

class DispatchRoutes extends React.Component {

  state = {
    header: ['N° de Guía','Fecha y Hora\nde Creación','Cantidad de\nPedidos','Zonas\nCubiertas','Vehículo','Conductor','Acciones'],
    page: 1,
    last_page: 1,
    data: [],
    status: [
      { value: STATUS.IN_PROGRESS, label: 'En tránsito' },
      { value: STATUS.FINISHED, label: 'Finalizada' },
      { value: STATUS.PENDING, label: 'Pendiente' },
    ],
    zones: [],
    form: INITIAL_FORM,
    user_id: this.props.user.id,
    item: null,
    visible: false,
    searchTimeout: null,
  };

  componentDidMount() {
    this.fetchData();
    this.getSelects();
  };

  componentWillUnmount() {
    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }
  }

  getSelects = async () => {
    Promise.all([
      axios.post('web/admin/zones', { user_id: this.props.user.id }),
    ]).then(res => {
      this.setState({
        zones: res[0].data.zones.map(i => ({ value: i.id, label: Globals.getZoneLabel(i) })),
      });
    });
  }

  fetchData = (page = 1) => {
    let { form } = this.state;

    form.user_id = this.props.user.id;

    axios
      .post("admin/dispatchroute?page=" + page, form)
      .then(res => {
        const data = res.data.data.data?.map(x => ({
          ...x,
          created_at_format: moment(x.created_at).format('DD/MM/YYYY hh:mm A'),
          status_text: this.getStatus(x.status).text,
          zones_text: x.zones.map(z => z.zone?.name || '').join(', '),
        }));

        this.setState({
          page,
          data,
          last_page: res.data.data.last_page,
        });
      })
      .catch(() => {
        Globals.showError();
      });
  };

  getStatus = (status) => {
    switch (status) {
      case STATUS.PENDING:
        return {
          text: "Pendiente",
          color: Colors.red,
        };

      case STATUS.IN_PROGRESS:
        return {
          text: "En tránsito",
          color: Colors.black,
        };

      case STATUS.FINISHED:
        return {
          text: "Finalizada",
          color: Colors.black,
        };

      default:
        return {
          text: "No definido",
          color: Colors.black,
        };
    }
  };

  change = (value, target) => {
    this.setState({
      form: {
        ...this.state.form,
        [target]: value
      }
    });
  };

  cleanFilters = async () => {
    this.setState({ form: INITIAL_FORM });
  }

  view = (item) => {
    this.setState({ visible: true, item });
  }

  edit = (item) => {
    this.setState({ visible_create: true, item });
    this.props.history.push(`/dispatch-routes/${item.number_format}/edit`);
  }

  print = (item) => {
    Swal.fire({
      title: 'Confirmar',
      text: 'Selecciona el formato de impresión',
      type: "question",
      showCancelButton: true,
      confirmButtonColor: '#3A7FC2',
      cancelButtonColor: '#3A7FC2',
      confirmButtonText: "General",
      cancelButtonText: "Detallado"
    }).then(async confirm => {
      const res = await axios.post('admin/dispatchroute', {
        user_id: this.props.user.id,
        download: true,
        download_type: confirm.value ? 1 : 2, // 1: general, 2: Detallada
        correlative_number: item.correlative_number,
      });

      console.log()
      if (res.data.url) {
        const win = window.open(res.data.url, "_blank");
        win.focus();
      } else {
        Globals.showError('Ha ocurrido un error');
      }
    });
  }

  delete = (id) => {
    Globals.confirm('¿Desea eliminar esta ruta?', () => {
      Globals.setLoading();
      axios.post('admin/dispatchroute/delete', { id })
      .then(res => {
        Globals.showSuccess(`Ruta eliminada con exito`);
        this.fetchData();
      })
      .catch(() => Globals.showError())
      .finally(() => Globals.quitLoading())
    })
  }

  close = () => {
    this.setState({
      visible: false,
      item: null
    });
  }

  autoFilter = (isText = false) => {
    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }
    if (isText) {
      const searchTimeout = setTimeout(() => {
        this.fetchData(1);
      }, 700);
      this.setState({ searchTimeout });
    } else {
      this.fetchData(1);
    }
  };

  change = (value, name, isText = false) => {
    this.setState(state => ({
      form: {
        ...state.form,
        [name]: value
      }
    }), () => {
      this.autoFilter(isText);
    });
  };

  cleanFilters = async () => {
    await this.setState({
      form: INITIAL_FORM
    });
  };

  render() {
    const { form, visible } = this.state;

    return (
      <Menu history={this.props.history}>
        {
          visible && (
            <Modal
              className="modal-view-route"
              title="Zonas de despacho"
              onClose={this.close}
              visible
            >
              <ModalView item={this.state.item} onClose={this.close} />
            </Modal>
          )
        }

        <div id="visit-planner">
          <div className="row">
            <div className="col-3">
              <Input
                color=" "
                label="Buscar"
                placeholder="Buscar por N° de Guía, conductor"
                className="filter"
                labelClass="filter"
                value={this.state.form.search ?? ""}
                onChange={e => this.change(e.target.value, 'search', true)}
              />
            </div>
            {/* <div className="col-2">
              <Select
                color="white"
                label="Estatus"
                placeholder="Todos"
                className="filter"
                labelClass="filter"
                options={this.state.status}
                value={this.state.form.status}
                onChange={e => this.change(e.target.value, 'status', false)}
              />
            </div> */}
            <div className="col-2">
              <Select
                color="white"
                label="Zonas"
                placeholder="Todos"
                className="filter"
                labelClass="filter"
                options={this.state.zones}
                value={this.state.form.zone_id}
                onChange={e => this.change(e.target.value, 'zone_id', false)}
              />
            </div>

            <div className="col-4 row">
              {
                (form.search !== '' || form.zone_id !== '' || form.status !== '') && (
                  <Button
                    className="btn-align-bottom btn-filter"
                    color=" "
                    onClick={async () => {
                      await this.cleanFilters();
                      this.fetchData(1);
                    }}
                  >
                    <span>Limpiar</span>
                  </Button>
                )
              }
            </div>
          </div>

          <Table
            data={this.state.data.length}
            header={this.state.header}
            right={
              <button
                style={{ padding: 0, border: 'none' }}
                onClick={() => this.props.history.push('/dispatch-routes/create')}
              >
                <div style={{ background: '#3A7FC2', color: '#fff', fontSize: '16px', padding: '8px 16px', borderRadius: '5px', display: 'flex', gap: '10px', alignItems: 'center' }}>
                  <span>Crear nueva guía</span>
                  <Icon name="plus" />
                </div>
              </button>
            }
          >
            {this.state.data.map((i, index) => {
              return (
                <tr key={index}>
                  <td>{ i.number_format }</td>
                  <td>{ i.created_at_format }</td>
                  <td>{ i.orders?.length }</td>
                  <td>{ i.zones_text }</td>
                  <td>{ i.vehicle }</td>
                  <td>{ i.driver }</td>
                  <td>
                    <Button
                      title="Ver"
                      small="true"
                      color="primary"
                      onClick={() => this.view(i)}
                    >
                      <Icon name="eye" />
                    </Button>
                    <Button
                      title="Editar"
                      small="true"
                      color="primary"
                      onClick={() => this.edit(i)}
                    >
                      <Icon name="edit" />
                    </Button>
                    <Button
                      title="Imprimir"
                      small="true"
                      color="primary"
                      onClick={() => this.print(i)}
                    >
                      <Icon name="download" />
                    </Button>
                    <Button
                      title="Eliminar"
                      small="true"
                      color="red"
                      onClick={() => this.delete(i.id)}
                    >
                      <Icon name="trash" />
                    </Button>
                  </td>
                </tr>
              );
            })}
          </Table>

          <Pagination
            pages={this.state.last_page}
            active={this.state.page}
            onChange={page => this.fetchData(page)}
          />
        </div>
      </Menu>
    );
  }
}

const ModalView = ({ item }) => {
  return (
    <div>
      <p>N° de Guía: <span>{ item?.number_format }</span></p>
      <p>Fecha y Hora de Creación: <span>{ item?.created_at_format }</span></p>
      <p>Vehículo: <span>{ item?.vehicle }</span></p>
      <p>Conductor: <span>{ item?.driver }</span></p>
      <p>Cantidad de Pedidos: <span>{ item?.orders?.length }</span></p>
      <p>Zonas Cubiertas: <span>{ item?.zones?.length }</span></p>
      <p>Zonas:</p>
      <ul className="route-list">
        {item?.zones?.map((route, index) => (
          <li key={index} className="route-item">{ route?.zone?.name }</li>
        ))}
      </ul>
    </div>
  );
}

export default connect(state => {
  return {
    user: state.user
  };
})(DispatchRoutes);
